import React, { useEffect } from "react";

import Navbar from "./clientHom/Navbar";
import Footer from "./uniComponents/AndUsFooter";
import WorkPassportPageHero from "./workPassport/WorkPassportPageHero";
import WorkPassportProductNavigation from "./workPassport/WorkPassportProductNavigation";
import WorkPassportComplianceProblem from "./workPassport/WorkPassportComplianceProblem";
import WorkPassportRequirementsModel from "./workPassport/WorkPassportRequirementsModel";
import WorkPassportReadinessJourney  from "./workPassport/WorkPassportReadinessJourney";
import WorkPassportCommandCentre from "./workPassport/WorkPassportCommandCentre";
import WorkPassportDigitalPassport from "./workPassport/WorkPassportDigitalPassport";
import WorkPassportRenewalScheduler from "./workPassport/WorkPassportRenewalScheduler";
import WorkPassportConnectedComplianceLoop  from "./workPassport/WorkPassportConnectedComplianceLoop";
import WorkPassportRoleBasedControl from "./workPassport/WorkPassportRoleBasedControl";
import WorkPassportControlledImplementation from "./workPassport/WorkPassportControlledImplementation";
import WorkPassportFinalDemonstrationCTA from "./workPassport/WorkPassportFinalDemonstrationCTA";

import "./WorkPassportPage.css";

export default function WorkPassportPage() {
  useEffect(() => {
    const previousTitle = document.title;

    document.title = "Work Passport | AndUs";
    window.scrollTo(0, 0);

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div id="work-passport-page-top" className="work-passport-page">
      <Navbar />

      <main className="work-passport-page__main">
        <WorkPassportPageHero />
        <WorkPassportProductNavigation />
        <WorkPassportComplianceProblem />
        <WorkPassportRequirementsModel />
        <WorkPassportReadinessJourney />
        <WorkPassportCommandCentre />
        <WorkPassportDigitalPassport />
        <WorkPassportRenewalScheduler />
        <WorkPassportConnectedComplianceLoop />
        <WorkPassportRoleBasedControl />
        <WorkPassportControlledImplementation />
        <WorkPassportFinalDemonstrationCTA />
        <div
          id="work-passport-page-content"
          className="work-passport-page__development-anchor"
          aria-hidden="true"
        />
      </main>

      <Footer />
    </div>
  );
}